
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaResume as ObiMediaResumeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-resume.js';
 
 
 

 
 export const ObiMediaResume = createComponent({
   react: React,
   tagName: 'obi-media-resume',
   elementClass: ObiMediaResumeElement,
   events: {
     
   }
  });
 
 